/**
 * Map backend hardcoded `detail` messages (often English) to i18n keys.
 * Backend does not currently localize these messages based on Accept-Language.
 */
export function translateServerDetail(detail, t) {
    if (!detail || typeof detail !== "string") return detail;

    const mapping = {
        // Campaign send/cancel/test
        "Open the survey before sending campaigns.": "survey.campaign.send.error.open_survey_before_sending",
        "This campaign is already sending or has been cancelled.": "survey.campaign.send.error.already_sent_or_cancelled",
        "Only draft or scheduled campaigns can be cancelled.": "survey.campaign.cancel.error.only_draft_or_scheduled",
        "This campaign cannot be deleted while sending.": "survey.campaign.delete.error.while_sending",
        "کمپین در حال ارسال قابل حذف نیست.": "survey.campaign.delete.error.while_sending",
        "Test send is available for addressed channels only.": "survey.campaign.test.error.addressed_channels_only",

        // Campaign recipients import/population
        "Recipients cannot be changed while sending or after cancellation.": "survey.campaign.recipients.import.error.only_before_sending",
        "Only platform-user campaigns can be populated from company users.": "survey.campaign.recipients.populate.error.only_platform_user",
        "Recipients cannot be added while sending or after cancellation.": "survey.campaign.recipients.populate.error.only_before_sending",

        // Survey edit / AI / public survey response
        "The survey is already archived.": "survey.archive.error.already_archived",
        "Archived surveys cannot be edited.": "survey.edit.error.archived_cannot_be_edited",
        "Questions cannot be changed after responses have been received.": "survey.structure.error",
        "AI service is not configured.": "survey.ai.error.not_configured",
        "AI service could not generate the form.": "survey.ai.error.could_not_generate_form",
        "AI service could not generate the message.": "survey.campaign.message.ai.error",
        "AI service could not generate the results summary.": "survey.ai.error.could_not_generate_summary",
        "Export link has expired.": "survey.export.error.link_expired",
        "Not found.": "survey.export.error.not_found",

        // Public survey
        "Survey link is invalid.": "survey.response.error.invalid_link",
        "This survey is no longer available.": "survey.response.error.no_longer_available",
        "This survey requires a personal invitation link.": "survey.response.error.requires_invitation",
        "This survey is not open for responses.": "survey.response.error.not_open",
        "This invitation has already been used.": "survey.response.error.invitation_used",
        "Login is required to answer this survey.": "survey.response.error.login_required",
        "Log in to submit this survey and receive coins.": "survey.response.error.login_required",
        "برای ثبت پاسخ و دریافت سکه باید وارد حساب کاربری شوید.": "survey.response.error.login_required",
    };

    const key = mapping[detail];
    return key ? t(key) : detail;
}

